import animationUi from './timelines/animations/ui';
import animationText from './timelines/animations/text';
import animationTitle from './timelines/animations/title';
import animationFade from './timelines/animations/fade';
import animationStagger from './timelines/animations/stagger';
import animationList from './timelines/animations/list';
import animationSlider from './timelines/animations/slider';
import animationFigure from './timelines/animations/figure';

import initialUi from './timelines/initial/ui';
import initialText from './timelines/initial/text';
import initialTitle from './timelines/initial/title';
import initialFade from './timelines/initial/fade';
import initialStagger from './timelines/initial/stagger';
import initialList from './timelines/initial/list';
import initialSlider from './timelines/initial/slider';
import initialFigure from './timelines/initial/figure';

import menu from './timelines/transitions/menu';
import { defaultIn, defaultOut } from './timelines/transitions/default';
import { motorcycleIn, motorcycleOut } from './timelines/transitions/motorcycle';
import { nextIn, nextOut } from './timelines/transitions/next';
import { nextIn2, nextOut2 } from './timelines/transitions/next2';

import hoverPointerImage from './timelines/hovers/pointer-image';

export const animations = new Map();
animations.set('ui', animationUi);
animations.set('text', animationText);
animations.set('title', animationTitle);
animations.set('fade', animationFade);
animations.set('stagger', animationStagger);
animations.set('list', animationList);
animations.set('slider', animationSlider);
animations.set('figure', animationFigure);

export const initial = new Map();
initial.set('ui', initialUi);
initial.set('text', initialText);
initial.set('title', initialTitle);
initial.set('fade', initialFade);
initial.set('stagger', initialStagger);
initial.set('list', initialList);
initial.set('slider', initialSlider);
initial.set('figure', initialFigure);

export const transition = new Map();
transition.set('menu', menu);
transition.set('default-in', defaultIn);
transition.set('default-out', defaultOut);
transition.set('motorcycle-in', motorcycleIn);
transition.set('motorcycle-out', motorcycleOut);
transition.set('next-in', nextIn);
transition.set('next-out', nextOut);
transition.set('next2-in', nextIn2);
transition.set('next2-out', nextOut2);

export const hovers = new Map();
hovers.set('pointer-image', hoverPointerImage);
